import { getRequestThietBi, postRequestThietBi } from "dataProvider";
import _ from "lodash";

export default class MapUtilService {
  async get(api, config) {
    try {
      let response = await getRequestThietBi(api, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      ) {
        return {
          ..._.omit(response.data, ["data"]),
          data: response.data.data
        };
      } else
        return {
          errors: response.data.errors
        };
    } catch (e) {
      if (e.response) {
        return {
          ...e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }

  async post(api, data, config) {
    try {
      let response = await postRequestThietBi(api, data, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      console.log(response);
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      if (e.response) {
        return {
          ...e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }

  async getCustom(api, config) {
    try {
      let response = await getRequestThietBi(api, config);

      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };

      return {
        errors: response.data.errors
      };
    } catch (e) {
      if (e.response) {
        return {
          ...e.response,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }
}
